import { RouterProvider } from 'react-router-dom';
import { Agentation } from 'agentation';
import { router } from './app/router';
import { installDevInputGuard } from './app/dev-input-guard';

// Before React mounts, so the guard stays ahead of the toolbar's own listener.
// See dev-input-guard.ts for the upstream cause; dead code in a production build.
if (import.meta.env.DEV) {
  installDevInputGuard();
}

export function App(): JSX.Element {
  return (
    <>
      <RouterProvider router={router} />
      {import.meta.env.DEV && <Agentation endpoint="http://localhost:4747" />}
    </>
  );
}

export default App;
